<template>

<div class="menu" :style="{marginTop: marginTop}"  :class="{'is-show': show}">

    <div class="menu-item is-close" v-if="$isMobile || ($isSmallDesktop && show)" v-on:click="$emit('close')">

        <div class="menu-item-icon"><i class="fa-sharp fa-remove" /></div>

    </div>

    <div class="menu-item is-close" v-if="$isSmallDesktop && !show" v-on:click="$emit('open')">

        <div class="menu-item-icon"><i class="fa-sharp fa-bars" /></div>

    </div>

    <app-router :to="{name: 'Home', params: { force: true }}" class="menu-item is-logo">

        <div class="menu-logo-icon"></div>
        <div class="menu-logo-text">geek<span>group</span></div>

    </app-router>

    <div class="menu-contexts">
    
        <app-router :to="{name: 'Default', params: {type: 'users', name: slug}}" class="menu-item" v-if="$loggedin">
            <core-avatar type="session" class="menu-item-icon" :tooltip="false" />
            <div class="menu-item-text">{{ sessionname }}<small>Your profile</small></div>
        </app-router>
    
        <app-router :to="{name: 'Default', params: {type: type, name: slug}}" class="menu-item" v-if="!$loggedin && $route.meta.isProfile">
            <core-avatar type="context" class="menu-item-icon" :tooltip="false" />
            <div class="menu-item-text">{{ contextname }}<small>User</small></div>
        </app-router>
        
        <app-router v-for="(group, index) in groups" :key="index" :to="{name: 'Default', params: {type: group.type, name: group.slug}}" class="menu-item">
            <core-avatar type="group" :group="group" class="menu-item-icon" :tooltip="false" />
            <div class="menu-item-text">{{ group.name }}<small>Group</small></div>
        </app-router>

        <app-router class="menu-item is-add ignore-link" v-if="!$loggedin && !$route.meta.isHome" :to="{name: 'Home', params: { force: true }}">
            <div class="menu-item-icon"><i class="fa-sharp fa-user-magnifying-glass" /></div>
            <div class="menu-item-text">Find Username</div>
        </app-router>

        <div class="menu-item is-add" v-if="$loggedin" v-on:click="onAddGroupClick">
            <div class="menu-item-icon"><i class="fa-sharp fa-plus" /></div>
            <div class="menu-item-text">Add Group</div>
        </div>

    </div>

    <div class="menu-user">
    
        <div class="menu-item" v-on:click="onUpdatesClick">
            <div class="menu-item-icon"><i class="fa-sharp fa-megaphone" /><div class="menu-item-count" v-if="unread" /></div>
            <div class="menu-item-text">News & Updates</div>
        </div>
    
        <app-router :to="{name: 'CommunityPatreon'}" class="menu-item" :class="{'router-link-active': $route.meta.isCommunity}">
            <div class="menu-item-icon"><i class="fa-brands fa-patreon" /></div>
            <div class="menu-item-text">Patreon</div>
        </app-router>
    
        <app-router :to="{name: 'Session'}" class="menu-item" v-if="$loggedin">
            <div class="menu-item-icon"><i class="fa-sharp fa-user" /></div>
            <div class="menu-item-text">My Account</div>
        </app-router>
    
        <div class="menu-item" v-if="!$loggedin" v-on:click="onLoginClick">
            <div class="menu-item-icon"><i class="fa-sharp fa-sign-in-alt" /></div>
            <div class="menu-item-text">Log in / Register</div>
        </div>

    </div>

</div>

</template>

<script>

export default {

    props: ['show'],

    computed: {

        marginTop: function() {

			if (this.$isDesktop) return false

            var offset = (0 - this.window.scrollY)

            if (offset < -40) offset = -40

            return offset.toString() + 'px'

        },

        unread: function() {
        
            return this.$store.getters['session/notifications']
        
        },
        
        slug: function() {

            return (this.$loggedin) ? this.$store.getters['session'].slug : this.$route.params.name

        },

		sessionname: function() {

			return this.$store.getters['session'].fullname || this.$store.getters['session'].name 

		},

		contextname: function() {

			return this.$store.getters['context'].fullname || this.$store.getters['context'].name 

		},

		type: function() {

			return this.$route.params.type

		},

        groups: function() {

            return this.$store.getters['session/groups']

        }

    },

    methods: {

        onAddGroupClick: function() {

			this.$pubsub.$emit('open.modal', 'groupCreate')

        },

        onUpdatesClick: function() {

			this.$pubsub.$emit('open.modal', 'appUpdates')

        },

        onLoginClick: function() {

			this.$pubsub.$emit('open.modal', 'userLogin')

        }

    }
	
}

</script>

<style scoped>

.menu {
    background-color: #184861;
    position: fixed;
    top: 0px;
    width: 64px;
    bottom: 0px;
    left: 0px;
    padding: 0px 0px 0px 0px;
    z-index: 400000002;
    display: grid;
    grid-template-rows: auto auto 1fr;
    padding: 11px;
    overflow: hidden;
    transition: width 100ms linear;
    grid-gap: 40px;
}

.is-mobile .menu {
    transition: left 100ms linear;
    grid-template-rows: 52px 52px auto 1fr;
    left: -64px;
    grid-gap: 0px;
    top: 40px;
    width: 52px;
    padding: 4px 6px 10px 6px;
}

.is-smaller .menu.is-show,
.is-mobile .menu.is-show {
    left: 0px;
}

.is-desktop .menu:hover {
    width: 384px;
}

.menu-contexts,
.menu-recent,
.menu-user {
    display: grid;
    grid-gap: 12px;
    align-content: start;
    grid-template-columns: 1fr;
}

.is-mobile .menu-contexts {
    grid-gap: 4px;
}

.menu-user {
    align-content: end;
}

.is-desktop .menu-contexts:before,
.is-desktop .menu-recent:before {
    content: '';
    display: block;
    width: 40px;
    height: 2px;
    background-color: rgba(0, 0, 0, 0.15);
    position: absolute;
    left: 0px;
    top: -21px;
}

.menu-logo {
    display: grid;
    grid-template-columns: 40px 1fr;
    width: 320px;
    grid-gap: 16px;
}

.menu-logo-icon {
    width: 40px;
    height: 40px;
    background-size: auto 36px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-image: url(~@/monty/assets/logo.svg);
    border-radius: 10px;
}

.is-mobile .menu-logo-icon {
    width: 32px;
    height: 32px;
    background-size: auto 28px;
    margin: 4px;
}

.menu-logo-text {
    font-size: 24px;
    line-height: 36px;
    height: 40px;
    letter-spacing: 1.5px;
    color: #fff;
    font-weight: 700;
    font-family: 'Barlow', sans-serif;
}

.menu-logo-text span {
    color: #ffc563;
}

.menu-item {
    width: 360px;
    display: grid;
    grid-template-columns: 40px 1fr;
    grid-gap: 16px;
    border-radius: 10px;
    cursor: pointer;
}

.menu-item-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    line-height: 40px;
    color: #fff;
    text-align: center;
    font-size: 16px;
}

.is-mobile .menu-item-icon {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background-size: auto 28px;
    margin: 4px;
}

.is-smaller .menu-item.is-logo {
    margin-top: -20px;
}

.menu-item.is-close .menu-item-icon {
    width: 32px;
    height: 32px;
    line-height: 34px;
    margin: 4px;
    border-radius: 50%;
    background-color: #4881bb;
    color: #fff;
}

.menu-item:before {
    display: block;
    content: '';
    position: absolute;
    border-radius: 10px;
    left: -6px;
    top: -6px;
    bottom: -6px;
    z-index: -1;
    width: 370px;
}

.is-smaller .menu-item:before {
    width: 52px;
}

.is-smaller .menu.is-show .menu-item:before {
    width: 370px;
}

.is-mobile .menu-item:before {
    top: -2px;
    bottom: -2px;
    left: -2px;
}

.menu-item:hover:before {
    background-color: #162B36;
}

.menu-item.router-link-active:not(.is-logo):not(.ignore-link):before {
    background-color: #2b5870;
}

.menu-item.is-add .menu-item-icon {
    background-color: #162B36;
}

.menu-item-icon.is-self {
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-image: url("https://img.geekgroup.app/api/users/avatar/1289151");
}

.menu-item-icon.is-bgg {
	background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAmCAMAAADtLHsqAAAAhFBMVEUAAAD/UQD/UQD/UAD/VwD/UQD/UQD/UQD/UQD/UQD/UAD/WAD/UQD/UQD/UAD/UQD/UgD/UAD/UgD/UQD/UQD/UAD/UQD/UAD/UAD/UQD/UAD/UQD/UQD/UAD/UQD/UQD/UAD/UAD/UAD/UAD/UAD/TwD/RwD/UQD/UQD/UQD/UQD/UQDHSOVYAAAAK3RSTlMAj+5vBcP6rUMoFAjnyYJeLyIb+eTi2M+5o6KblIp+d2RcVU40LQz36dWxGXtUPwAAAN9JREFUOMt1k9cWgjAQRBNARATEjvRu2f//P5MAShnu49wTmF0IwxxTHeZ29ibztMzbQ2AS0WMhrFAjRTPNd8mVeoLJC3SX/li/3Cg/ZxrhDsLnDk3Ry2grDuh3QkhlEoSLx12xktvYYFUJFWLlC+Vh1QqVQ6OptUF1V58Gj6WWtDKW5ILHEhw1pBJhGocgMWM3WsFinDAXg+0Ik66u92kLVUClfrY9LF9LBYu4ysAihRSwiGP06rBQnoxRkfE1iWcqkiEocsu6M/MiL14P2aTIeVvtZ6IrsslthvC4v8i+Ki9rOlCl3nQAAAAASUVORK5CYII=');
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: auto 26px;
    background-color: rgba(0, 0, 0, 0.15);
}

.menu-item:hover .menu-item-icon.is-bgg {
    background-color: transparent;
}

.menu-item-text {
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    letter-spacing: 2px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.menu-item.is-add .menu-item-text {
    opacity: 0.65;
}

.menu-item.is-add:hover .menu-item-text {
    opacity: 1;
}

.menu-item.is-active .menu-item-text {
    color: #f6c86c;
}

.menu-item-text small {
    font-size: 12px;
    opacity: 0.5;
    display: block;
    color: #fff!important;
    margin-top: 2px;
}

.menu-item-count {
    background-color: #f64b4b;
    position: absolute;
    right: -2px;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

</style>
